module.exports = __webpack_public_path__ + "assets/img/partners.8832b3dd.jpg";